import L from 'leaflet';
import * as topojson from 'topojson-client';
import { keys } from 'lodash';

L.TopoJSON = L.GeoJSON.extend({
  addData(data) {
    let geojson;
    if (data.type === 'Topology') {
      const objectKey = keys(data.objects)[0];
      geojson = topojson.feature(data, data.objects[objectKey]);
      L.GeoJSON.prototype.addData.call(this, geojson);

      return this;
    }
    L.GeoJSON.prototype.addData.call(this, data);
    return this;
  }
});

L.topoJson = (data, opts) => new L.TopoJSON(data, opts);

/**
 * Creates an instance of TopoJSON layer for Leaflet.
 *
 * @param {object} data - The options of the layer.
 * @param {object} opts - The options of the layer.
 */
const customTopoJSON = (data, opts) => {
  const topojsonLayer = L.topoJson(null, opts);
  topojsonLayer.addData(data);
  return topojsonLayer;
};

export default customTopoJSON;
